import React from 'react';
import { Col, Row } from 'components/Core/Grid';
import RowContainer from 'components/RowContainer';
import Column from 'components/Column';
import getJustify from './utils/getJustify';
import getAlignment from './utils/getAlignment';
import getDirection from './utils/getDirection';

import { StyledRow } from './styles';

const ContentfulRow = ({
  alignMobile,
  alignDesktop,
  columns,
  horizontalGutterDesktop,
  horizontalGutterMobile,
  justifyMobile,
  justifyDesktop,
  styles,
  verticalGutterDesktop,
  verticalGutterMobile,
  contentDirectionMobile,
  contentDirectionDesktop,
  reverseOrderMobile,
  reverseOrderDesktop,
  anchorId,
  childRow,
  parentBackgroundColor,
  parentAlignDesktop,
  useCtaParentRouting,
}) => {
  const {
    backgroundColor,
    customBackgroundDesktop,
    customBackgroundMobile,
    backgroundImage,
    heightDesktop,
    heightMobile,
    hideOnMobile,
    hideOnDesktop,
    marginMobile,
    marginDesktop,
    paddingMobile,
    paddingDesktop,
    maxWidthMobile,
    maxWidthDesktop,
    customStyling,
  } = styles || {};
  const backgroundImageUrl = backgroundImage?.image?.file?.url;
  const colAlignMobile = getAlignment(alignMobile);
  const colAlignDesktop = getAlignment(alignDesktop);
  const colJustifyMobile = getJustify(justifyMobile);
  const colJustifyDesktop = getJustify(justifyDesktop);
  const colDirectionDesktop = getDirection(contentDirectionDesktop, reverseOrderDesktop);
  const mobileDisplay = hideOnMobile ? 'none' : 'block';
  const desktopDisplay = hideOnDesktop ? 'none' : 'block';
  const hasGutter =
    horizontalGutterDesktop ||
    horizontalGutterMobile ||
    verticalGutterDesktop ||
    verticalGutterMobile;

  return (
    <RowContainer
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImageUrl}
      customBackgroundDesktop={customBackgroundDesktop}
      customBackgroundMobile={customBackgroundMobile}
      $childRow={childRow}
      displayMobile={mobileDisplay}
      displayDesktop={desktopDisplay}
      heightDesktop={heightDesktop}
      heightMobile={heightMobile}
      marginMobile={marginMobile}
      marginDesktop={marginDesktop}
      paddingMobile={paddingMobile}
      paddingDesktop={paddingDesktop}
      maxWidthMobile={maxWidthMobile}
      maxWidthDesktop={maxWidthDesktop}
      id={anchorId}
    >
      <Row justify="center" align="middle" type="flex">
        <Col xs={24}>
          <StyledRow
            className="styled-row"
            $justifyMobile={colJustifyMobile}
            $justifyDesktop={colJustifyDesktop}
            $alignMobile={colAlignMobile}
            $alignDesktop={colAlignDesktop}
            $contentDirectionMobile={contentDirectionMobile}
            $reverseOrderMobile={reverseOrderMobile}
            $contentDirectionDesktop={colDirectionDesktop}
            $childRow={childRow}
            $parentAlignDesktop={parentAlignDesktop}
            $customStyling={customStyling}
            type="flex"
            {...(hasGutter
              ? {
                  gutter: [
                    {
                      ...(horizontalGutterMobile && { xs: parseFloat(horizontalGutterMobile) }),
                      ...(horizontalGutterDesktop && { sm: parseFloat(horizontalGutterDesktop) }),
                    },
                    {
                      ...(verticalGutterMobile && { xs: parseFloat(verticalGutterMobile) }),
                      ...(verticalGutterDesktop && { sm: parseFloat(verticalGutterDesktop) }),
                    },
                  ],
                }
              : {})}
          >
            {columns?.map((column, index) => {
              return (
                <Column
                  {...column}
                  key={index}
                  parentAlignDesktop={colAlignDesktop}
                  justifyMobile={colJustifyMobile}
                  justifyDesktop={colJustifyDesktop}
                  colLength={columns.length}
                  justify="top"
                  align="middle"
                  parentBackgroundColor={parentBackgroundColor}
                  useCtaParentRouting={useCtaParentRouting}
                />
              );
            })}
          </StyledRow>
        </Col>
      </Row>
    </RowContainer>
  );
};

export default ContentfulRow;
